"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const OptionsButton_1 = __importDefault(require("../../atoms/OptionsButton"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const useCutOptions_1 = require("../../hooks/useCutOptions");
const providers_1 = require("../../providers");
function ToolsCutLayersPanel({ className, type }) {
    const bridge = (0, bridge_1.useBridge)();
    const containerRef = (0, react_1.useRef)(null);
    const [selectedType, setSelectedType] = (0, react_1.useState)(type);
    const tools = (0, providers_1.useToolsService)();
    const cutManager = tools === null || tools === void 0 ? void 0 : tools.getThreeDToolManager();
    const { subtype } = (0, useCutOptions_1.useCutOptions)();
    const selectSingleLayer = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: bridge_schema_1.ToolType.SingleCutLayer,
            currentOptions: {
                type: bridge_schema_1.ToolType.SingleCutLayer,
                cutMode: bridge_schema_1.ToolType.SingleCutLayer,
                lineIsDrawn: false,
            },
        });
        cutManager === null || cutManager === void 0 ? void 0 : cutManager.updateCutOptions({
            subtype: subtype,
            type: bridge_schema_1.ToolType.SingleCutLayer,
        });
        setSelectedType(bridge_schema_1.ToolType.SingleCutLayer);
    };
    const selectMultiLayer = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: bridge_schema_1.ToolType.MultiCutLayer,
            currentOptions: {
                type: bridge_schema_1.ToolType.MultiCutLayer,
                cutMode: bridge_schema_1.ToolType.MultiCutLayer,
                lineIsDrawn: false,
            },
        });
        cutManager === null || cutManager === void 0 ? void 0 : cutManager.updateCutOptions({
            subtype: subtype,
            type: bridge_schema_1.ToolType.MultiCutLayer,
        });
        setSelectedType(bridge_schema_1.ToolType.MultiCutLayer);
    };
    const onClick = (event) => {
        event.stopPropagation();
    };
    const events = (0, ui_1.getPointersEvents)();
    (0, ui_1.useEvent)(containerRef, events.down, onClick);
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, className: className, "data-e2e": 'ToolsCutLayersPanel_Container', children: [(0, jsx_runtime_1.jsx)(ButtonContainer, { selected: selectedType === bridge_schema_1.ToolType.SingleCutLayer, "data-e2e": 'ToolsCutLayersPanel_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ui_1.PushInAnimation, { delay: 200, "data-e2e": 'ToolsCutLayersPanel_PushInAnimation', children: (0, jsx_runtime_1.jsx)(OptionsButton_1.default, { selected: selectedType === bridge_schema_1.ToolType.SingleCutLayer, onClick: selectSingleLayer, className: "singleCutLayerButton", "data-e2e": 'ToolsCutLayersPanel_OptionsButton', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { active: selectedType === bridge_schema_1.ToolType.SingleCutLayer, name: ui_1.Icons.Single_Layer, "data-e2e": 'ToolsCutLayersPanel_ButtonIcon' }) }) }) }), (0, jsx_runtime_1.jsx)(ButtonContainer, { selected: selectedType === bridge_schema_1.ToolType.MultiCutLayer, "data-e2e": 'ToolsCutLayersPanel_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ui_1.PushInAnimation, { delay: 200, "data-e2e": 'ToolsCutLayersPanel_PushInAnimation', children: (0, jsx_runtime_1.jsx)(OptionsButton_1.default, { selected: selectedType === bridge_schema_1.ToolType.MultiCutLayer, onClick: selectMultiLayer, className: "multiCutLayerButton", "data-e2e": 'ToolsCutLayersPanel_OptionsButton', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { active: selectedType === bridge_schema_1.ToolType.MultiCutLayer, name: ui_1.Icons.Multi_Layers, "data-e2e": 'ToolsCutLayersPanel_ButtonIcon' }) }) }) })] }));
}
exports.default = ToolsCutLayersPanel;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
const ButtonContainer = styled_components_1.default.div `
  position: absolute;
  bottom: 0;

  transform: translateY(${({ selected }) => (selected ? 0 : '-70px')});

  transition: transform 0.2s ease-in;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 40px;
  height: 40px;

  transition: fill 0.2s ease-in;

  fill: ${props => props.active
    ? props.theme.tools.header.textbox.colors.white
    : props.theme.backgroundQuinary};
`;
